// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"670bc08e","453":"edcdd3ed"}[chunkId] + ".chunk.js";
};